import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import {
  textColorLight,
  linkAccent,
  linkHoveredAccent,
  breakpoint4k,
  breakpointLarge,
} from "../variables"
import { navData } from "../navData"

const isMauiHarvest = name => {
  if (name === "Maui Harvest") {
    return true
  } else {
    return false
  }
}

const Navigation = () => {
  return (
    <NavContainer>
      {navData.map(link => (
        <Link
          key={link.name}
          to={link.to}
          className={isMauiHarvest(link.name) ? "maui-harvest" : undefined}
        >
          {link.name}
        </Link>
      ))}
    </NavContainer>
  )
}

export default Navigation

const NavContainer = styled.nav`
  display: none;

  a {
    padding: 11px 26px;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: ${textColorLight};
  }

  .maui-harvest {
    background: ${linkAccent};

    &:hover {
      background: ${linkHoveredAccent};
    }
  }

  @media (min-width: ${breakpointLarge}) {
    display: block;
  }

  @media (min-width: ${breakpoint4k}) {
    a {
      font-weight: 600;
    }
  }
`
